import React, { useState, useEffect } from "react";
import {
  makeStyles,
  Button,
  Box,
  InputAdornment,
  Tabs,
  Tab,
  withStyles,
  FormControlLabel,
  Checkbox,
  Divider,
  Grid,
  MenuItem,
} from "@material-ui/core";
import { Link } from "react-router-dom";
import { TextField } from "formik-material-ui";
import { Field, Form, Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import PhoneIcon from "@material-ui/icons/Phone";
import AccountCircle from "@material-ui/icons/AccountCircle";
// import BodyText from './BodyText';
import EmailIcon from "@material-ui/icons/Email";
import LockIcon from "@material-ui/icons/Lock";
// import { loginDispatch } from '../reducers/UsersReducer';
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import SuccessModal from "../components/reusableComponents/SuccessModal";
import ErrorModal from "../components/reusableComponents/ErrorModal";
import {
  agentloginDispatch,
  agentSignupDispatch,
  travellerSignupDispatch,
} from "../reducers/UserReducer";
// import RegisterAgentModal from "../components/reusableComponents/RegisterAgentModal";
import { flightHolidayEnquiry } from "../reducers/HomeReducer";
import LoaderModal from "../components/reusableComponents/LoaderModal";
// import { useDispatch } from 'react-redux';
const useStyles = makeStyles((theme) => ({
  selectField: {
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        border: "1px solid rgba(0, 50, 91, 0.5)",
      },
    },
    "& .MuiFormHelperText-root": {
      backgroundColor: "#F6F8FB",
      margin: 0,
      paddingTop: 5,
    },
    "& .MuiSelect-icon": {
      color: "#E61855",
    },
    "& div": {
      fontSize: 18,
    },
    "& input": {
      padding: "12.5px 14px",
      border:'1px solid'
    },
    "& .MuiSelect-select": {
      padding: "12.5px 14px",
    },

    backgroundColor: "white",
    // marginBottom: 20,
    width: "100%",
    // marginTop: 10,
    borderRadius: 15,
    [theme.breakpoints.down("xs")]: {
      marginBottom: 0,
      marginTop: 8,
    },
  },
  InputPropsStyle: {
    backgroundColor: "#F6F8FB",
    borderRadius: 8,
    fontSize: 18,
  },
  inputPropsStyle: {
    // padding: 14,
    fontWeight: "bold",
    display: "flex",
    alignItems: "center",
    backgroundColor: "#F6F8FB",
  },
  createButton: {
    backgroundColor: "rgb(0, 87, 94)",
    color: "white",
    borderColor: "#E61855",
    borderRadius: 6,
    width: "100px",
    padding: 8,
    fontSize: 16,
    marginBottom: 20,
    "&:hover": {
      backgroundColor: "rgb(0, 87, 94)",
    },
  },
  tabBorder: {
    borderBottom: "2px solid transparent",
    color: "#7B95AB",
    fontWeight: 400,
  },
  tabBorderColor: {
    borderBottom: "2px solid #313131",
    color: "#00325B",
    fontWeight: 700,
  },
  tab: {
    [theme.breakpoints.up("sm")]: {
      "& .MuiTab-root": {
        minWidth: 241,
        fontSize: 22,
      },
    },
  },
}));
// const country = ['INDIA', 'SRILANKA'];
const GreenCheckbox = withStyles({
  root: {
    color: "#39c9bb",
    "&$checked": {
      color: "#39c9bb",
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);
const country = ["Jharkhand", "Kolkata"];
const title = ["Mr", "Mrs"];
const LoginB2B = () => {
  const classes = useStyles();
  // const theme = useTheme();
  const [tabvalue, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const [check, setCheck] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const handleCheck = (event) => {
    setCheck(event.target.checked);
  };
  const { travellermodal, holidaySelect } = useSelector((state) => state.ui);
  const { loading } = useSelector((state) => state.home);
  const [currentStep, SetCurrentStep] = useState("Step 1");

  const handleFormSubmit = (data, actions) => {
    let formData = {
      username:data.email,
      password:data.password
    };
    console.log(formData);
    dispatch(agentloginDispatch(formData,history));
    // dispatch(flightHolidayEnquiry(formData));
  };

  return (
    <>
      <Formik
        initialValues={{}}
        validate={(values) => {
          const errors = {};

          // if (!values.currentpassword) {
          // 	errors.currentpassword = 'Required';
          // }
          // if (!values.newpassword) {
          // 	errors.newpassword = 'Required';
          // }
          // if (!values.confirmnewpassword) {
          // 	errors.confirmnewpassword = 'Required';
          // }

          return errors;
        }}
        onSubmit={handleFormSubmit}
      >
        {({ submitForm, isSubmitting, values, errors }) => (
          <>
            <Form>
              <Grid container>
                <Grid item xs={2}></Grid>
                <Grid
                  item
                  xs={8}
                  style={{
                    background: "white",
                    padding: 20,
                    boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
                    borderRadius: 5,
                  }}
                >
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} lg={12} style={{ textAlign: "center" }}>
                    <h2 style={{ fontFamily: "cursive", fontSize: "40px",color:'#990000' }}>
                       Demo
                      </h2>
                      <span style={{ fontFamily: "cursive", fontSize: "23px" }}>
                        Welcome!
                      </span>
                      <p>Login to Continue</p>
                    </Grid>
                    {/* <Grid item xs={12} lg={12}>
                      <span style={{ fontFamily: "Poppins, sans-serif" }}>
                        Terminal ID
                      </span>
                      <Field
                        component={TextField}
                        name="phone"
                        type="number"
                        variant="outlined"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      />
                    </Grid> */}
                  </Grid>
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} lg={12}>
                      <span style={{ fontFamily: "Poppins, sans-serif" }}>
                        Username
                      </span>
                      <Field
                        component={TextField}
                        name="email"
                        type="email"
                        variant="outlined"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} lg={12}>
                      <span style={{ fontFamily: "Poppins, sans-serif" }}>
                        {" "}
                        Password
                      </span>
                      <Field
                        component={TextField}
                        name="password"
                        type="password"
                        variant="outlined"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    style={{ marginTop: 10 }}
                  >
                    <Button
                      className={classes.createButton}
                      onClick={submitForm}
                      style={{ marginTop: 5, fontSize: 14, fontWeight: "bold",cursor:'pointer' }}
                      // disabled={isSubmitting}
                    >
                      Submit
                    </Button>
                    <span style={{cursor:'pointer'}} onClick={()=>history.push('/resetpassword')}>Forgot Password?</span>
                  </Box>
                </Grid>
                <Grid item xs={2}></Grid>
              </Grid>
            </Form>
          </>
        )}
      </Formik>
      <SuccessModal />
      <ErrorModal />
      {loading ? <LoaderModal /> : ""}
    </>
  );
};

export default LoginB2B;
